/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tier_Delete_DescInputs */

const vi_shop_tier_delete_desc = /** @type {(inputs: Shop_Tier_Delete_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách đang ở hạng này sẽ được tính lại theo các hạng còn lại.`)
};

/**

* @param {Shop_Tier_Delete_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_delete_desc = /** @type {((inputs?: Shop_Tier_Delete_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_Delete_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_delete_desc(inputs)
});